import * as React from "react";
import { usePerformAction } from "react-remote-data-hooks";
import api from "../../../../api";
import {
  LeadAssignmentSettings,
  convertPascalCaseToWords,
  LeadActivitySettingsData,
} from "../../../../core";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import UpdateForm from "./UpdateForm";

interface IQuotationSettingsProps {
  data?: LeadActivitySettingsData;
  reload?: () => void;
}

const LeadActivitySettingsTab: React.FunctionComponent<IQuotationSettingsProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: LeadActivitySettingsData) =>
      api.settings.updateLeadActivitySettings({
        ...data,
        noOfDaysToAllowBackdatedActivity: data.noOfDaysToAllowBackdatedActivity
          ? Number(data.noOfDaysToAllowBackdatedActivity)
          : undefined,
      }),
    () => {
      props.reload?.();
      setEditModalOpen(false);
      appSettings.reload();
    }
  );

  const renderDetails = (data: string[]) => {
    return (
      <td>
        {data?.map((crm, index) => {          
          return (
            <>
              {convertPascalCaseToWords(crm === "CallCenterExecutive" ?
                "BusinessDeveloperExecutive" : crm === "Agent" ?
                  "TransactionExecutive" : crm)}
              {index !== (data?.length || 1) - 1 && <>, </>}
            </>
          );
        })}
      </td>
    );
  };

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">
              Lead Activity Settings
            </h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Activity Type
                  </span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    User Types
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Request Callback</td>
                {renderDetails(props.data?.requestACallBack ?? [])}
              </tr>
              <tr>
                <td>Schedule Site Visit</td>
                {renderDetails(props.data?.showroomVisit ?? [])}
              </tr>
              <tr>
                <td>Other Activity</td>
                {renderDetails(props.data?.otherActivity ?? [])}
              </tr>
              <tr>
                <td>No. of days to allow backdated activity</td>
                <td>{props.data?.noOfDaysToAllowBackdatedActivity}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default LeadActivitySettingsTab;
